import type { IDrag } from "./DragAndDropContext";
import { useDragAndDropContext } from "./DragAndDropContext";

/** When true, visit tiles should not capture pointer events so the route drop zone beneath stays droppable. */
export const shouldDisablePointerEventsForRouteDropZone = ({
  drag,
  routeId,
}: {
  drag: IDrag | undefined;
  routeId: string;
}): boolean => {
  if (!drag) {
    return false;
  }
  if (drag.source !== "route" && drag.source !== "sidebar") {
    return false;
  }
  const dragSourceRouteId = drag.source === "route" ? drag.routeId : undefined;
  return dragSourceRouteId !== routeId;
};

export const useShouldDisablePointerEventsForRouteDropZone = ({
  routeId,
}: {
  routeId: string;
}) => {
  const { drag } = useDragAndDropContext();
  return shouldDisablePointerEventsForRouteDropZone({
    drag,
    routeId,
  });
};
